import { inject } from '../../container/inject';
import { EntityListStoreToken, IEntityListStore, IEntityListStoreFactory } from '../interface/IEntityListStore';

export function injectEntityList<Type>(defaultValue: Type[]): IEntityListStore<Type> {
  return inject<IEntityListStoreFactory<Type>>(EntityListStoreToken)(defaultValue);
}
